export default __webpack_public_path__ + "static/media/dog.5b01e301.svg";